import React from 'react';
const vols = [{
  n: '01',
  name: 'Arrive & Connect',
  fill: '#C8613F',
  angle: -30
}, {
  n: '02',
  name: 'Grounded Bodies',
  fill: '#5B7857',
  angle: -18
}, {
  n: '03',
  name: 'Expression in Motion',
  fill: '#526E89',
  angle: -6
}, {
  n: '04',
  name: 'Relationship',
  fill: '#3B2440',
  angle: 6
}, {
  n: '05',
  name: 'Energy & Play',
  fill: '#B9801F',
  angle: 18
}, {
  n: '06',
  name: 'Seasons & Endings',
  fill: '#A24A2C',
  angle: 30
}];
const serif = 'Fraunces, Georgia, serif';
const sans = '"Nunito Sans", system-ui, sans-serif';

/** Fallback pack visual, shown while no mockup image URL is set. */
export function PackIllustration({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 600 400" role="img" aria-label="Movement Group Ready: six volumes fanned out" className={`w-full h-auto ${className}`} data-id="element-183" data-mp="32afmmhyp5yvi">
      <circle cx="300" cy="230" r="180" fill="#F6E1D6" data-id="element-184" data-mp="2nfhspknwh1cb" />
      <path d="M60 330 C 160 300, 140 120, 300 110 S 470 60, 560 40" fill="none" stroke="#C8613F" strokeOpacity="0.4" strokeWidth="3" strokeDasharray="2 10" strokeLinecap="round" data-id="element-185" data-mp="2sbgdyzdxm38i" />
      {vols.map(v => <g key={v.n} transform={`rotate(${v.angle} 300 470)`} data-id="element-186" data-mp="29ro3dvq1bd92">
          <rect x="231" y="124" width="140" height="196" rx="14" fill="#3B2440" opacity="0.16" data-id="element-187" data-mp="29pttrdk7r7ka" />
          <rect x="230" y="120" width="140" height="196" rx="14" fill={v.fill} data-id="element-188" data-mp="25r4aj4chuvsq" />
          <rect x="230" y="120" width="140" height="46" rx="14" fill="#FFFDF8" fillOpacity="0.14" data-id="element-189" data-mp="1i19vqh8m6x5u" />
          <text x="244" y="139" fontSize="8.5" fontWeight="800" fill="#FFFDF8" fontFamily={sans} letterSpacing="1.2" data-id="element-190" data-mp="1d38d1xf3ozuw">
            MOVEMENT
          </text>
          <text x="244" y="155" fontSize="12" fontWeight="700" fill="#F8D9A0" fontFamily={serif} data-id="element-191" data-mp="1m2llqnvehkek">
            Group Ready
          </text>
          {/* Top-down circle of the group with the facilitator star */}
          <g fill="none" stroke="#FFFDF8" data-id="element-192" data-mp="ubz4bqd5mf4d">
            <circle cx="300" cy="226" r="34" strokeOpacity="0.75" strokeWidth="1.5" data-id="element-193" data-mp="uaxh6niv626a" />
            <path d="M272 252 Q 300 196 330 214" strokeDasharray="2 4" strokeOpacity="0.9" strokeWidth="1.5" data-id="element-194" data-mp="2tfe9jvlb729q" />
          </g>
          {[0, 60, 120, 180, 240, 300].map(a => {
        const r = a * Math.PI / 180;
        return <circle key={a} cx={300 + Math.cos(r) * 34} cy={226 + Math.sin(r) * 34} r="5" fill="#FFFDF8" data-id="element-195" data-mp="33838xs3l4pop" />;
      })}
          <circle cx="300" cy="226" r="7" fill="#E3A33B" data-id="element-196" data-mp="2ahbf319zsd4j" />
          <text x="244" y="293" fontSize="8" fontWeight="700" fill="#FFFDF8" fillOpacity="0.85" fontFamily={sans} data-id="element-197" data-mp="2aiwbkwfva651">
            {v.name.toUpperCase()}
          </text>
          <text x="244" y="307" fontSize="12" fontWeight="800" fill="#FFFDF8" fontFamily={sans} data-id="element-198" data-mp="2ke7r3gz3nhdu">
            VOL. {v.n}
          </text>
        </g>)}
      <circle cx="512" cy="88" r="48" fill="#E3A33B" data-id="element-199" data-mp="2pbzkkffe7bk5" />
      <text x="512" y="94" textAnchor="middle" fontSize="32" fontWeight="700" fill="#3B2440" fontFamily={serif} data-id="element-200" data-mp="3vtmlqe3u5x5s">
        54
      </text>
      <text x="512" y="112" textAnchor="middle" fontSize="9" fontWeight="800" fill="#3B2440" fontFamily={sans} letterSpacing="1" data-id="element-201" data-mp="4pxzn2o1qe6p">
        SESSIONS
      </text>
    </svg>;
}